<template>
  <div class="listFrame">
    <main class="t-main">
      <ol class="m-breadcrumb">
        <li class="m-breadcrumb__item"><span class="a-text">枠一覧</span></li>
      </ol>
      <h1 class="a-title">{{ listFrameTitle }}</h1>
      <div class="m-form__item-wrapper">
        <div class="m-form__item m-form__item--50">
          <label class="m-form__label">fqdn<span class="m-form__input--select-wrapper">
             <select class="m-form__input m-form__input--select" name="category" v-model="fqdn" @change="changeDomain">
               <option value="" disabled>--選択してください--</option>
               <option v-for="domain in domains" v-bind:value="domain.fqdn">{{ domain.fqdn }}</option>
             </select></span></label>
        </div>
      </div>
      <div v-if="fqdn">
        <div class="m-form__item-wrapper">
          <button class="a-button" v-on:click="createframelink">新規登録</button>
        </div>
        <br/>
        <br/>
        <div class="m-form__item-wrapper">
          <div class="m-form__item m-form__item--50">
            <label class="m-form__label">--絞り込み--
              <input class="m-form__input m-form__input--text" type="text" placeholder="Filter..."
                     v-model="searchQuery">
            </label>
          </div>
        </div>
        <br/>
        <div class="a-section">
          <table class="m-table">
            <thead>
            <tr>
              <th>{{ columns.name }}</th>
              <th>{{ columns.mtime }}</th>
              <th>{{ columns.utime }}</th>
              <th>{{ columns.delete }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="task in filteredTasks">
              <td>
                <router-link v-bind:to="{ path: 'get-frame', query: { frameId: task.frameId, fqdn: fqdn}}">{{
                  task.metadata.name }}
                </router-link>
              </td>
              <td>{{ task["mtime"] | moment }}</td>
              <td>{{ task["utime"] | moment }}</td>
              <td><a class="m-form__delete" v-on:click="deleteFrame(task)"></a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import store from '../../../stores'
  import moment from 'moment'

  export default {
    name: 'listFrame',
    data() {
      const columns = {frameId: '枠ID', name: '枠名', mtime: '作成日時', utime: '更新日時', delete: '削除'}
      return {
        listFrameTitle: '枠一覧',
        columns,
        fqdn: '',
        searchQuery: ''
      }
    },
    // 初回コンポーネント作成
    created() {
      store.dispatch('checkSessionId')
      store.dispatch('getFrameListData', this.$route.query.fqdn)
      store.dispatch('getDomainListData')
    },
    // ajaxで取得してきた
    computed: {
      tasks() {
        return store.state.frame.framelist
      },
      domains() {
        return store.state.frame.domainlist
      },
      filteredTasks() {
        if (!this.searchQuery) return this.tasks
        const regexp = new RegExp(this.searchQuery, 'i')

        return this.tasks.filter(task => {
          return regexp.test(task.metadata.name)
        })
      }
    },
    methods: {
      callframelist: function () {
        store.dispatch('framelist', this.tasks)
      },
      createframelink: function () {
        this.$router.push('/delivery/create-frame?fqdn=' + this.fqdn)
      },
      changeDomain: function () {
        // 選択ドメインの枠を呼び出す
        store.dispatch('getFrameListData', this.fqdn)
        this.$router.push('/delivery/list-frame?fqdn=' + this.fqdn)
      },
      deleteFrame: function (frame) {
        if (confirm(frame.fqdn + 'に登録された' + frame.frameId + 'のバージョン' + frame.versionId + 'を削除しますか？')) {
          store.dispatch('frameDelete', frame)
        }
      }
    },
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY/MM/DD HH:mm')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/delivery/frame/ListFrame.vue